import type { ModalContentType, ModalParams } from "domains/modal/types";

export enum ModalTypes {
  ACTIVATE = "[Modal] - Activate",
  DEACTIVATE = "[Modal] - Deactivate",
  PUSH_SCREEN = "[Modal] - Push screen",
  POP_SCREEN = "[Modal] - Pop screen",
}

export type ModalActivateAction<T extends ModalContentType> = {
  meta: ModalMeta<T>;
  type: ModalTypes.ACTIVATE;
};

export type ModalDeactivateAction = { type: ModalTypes.DEACTIVATE };

export type ModalPushScreenAction<T extends ModalContentType> = {
  meta: ModalMeta<T>;
  type: ModalTypes.PUSH_SCREEN;
};

export type ModalPopScreenAction = { type: ModalTypes.POP_SCREEN };

type ModalMeta<T extends ModalContentType> = { id: T } & ParamsField<ModalParams<T>>;

type ParamsField<T> = RequiredKeys<T> extends never ? { params?: T } : { params: T };

type RequiredKeys<T> = { [K in keyof T]-?: Record<string, never> extends Pick<T, K> ? never : K }[keyof T];

export type ModalAction =
  | ModalActivateAction<ModalContentType>
  | ModalDeactivateAction
  | ModalPushScreenAction<ModalContentType>
  | ModalPopScreenAction;
